// eslint-disable-next-line
import { queryFilterDashboard } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const getItemSaleFilter = (queryFilter: queryFilterDashboard) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/item-sale/?${params.toString()}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };
const getLowHighStockFilter = (queryFilter: queryFilterDashboard) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.dashboard.dashboard}/low-high-stock/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};
const getItemShrinkageFilter = (queryFilter: queryFilterDashboard) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/shrinkage/locations/?${params.toString()}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };
const getItemShrinkageByLocation = (orgId: string, locationId: string) => {
    const method = methods.GET;
  
    const url = `${urls.dashboard.dashboard}/shrinkage/organization/${orgId}/location/${locationId}/categories`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };
const getItemShrinkageByCategory = (locationId: string, categoryId: string) => {
    const method = methods.GET;
  
    const url = `${urls.dashboard.dashboard}/shrinkage/location/${locationId}/category/${categoryId}/items`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };
const getItemInventoryFilter = (queryFilter: queryFilterDashboard) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
  
    const url = `${urls.dashboard.dashboard}/inventory/?${params.toString()}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

export {
    getItemSaleFilter,
    getLowHighStockFilter,
    getItemShrinkageFilter,
    getItemInventoryFilter,
    getItemShrinkageByLocation,
    getItemShrinkageByCategory
};
